export const ALLIANZ_ID = 1;
export const DLG_ID = 67;
export const LV_ID = 74;
export const VIZION_ID = 327;
export const NARG_ID = 90;

export const enableConnectionList = [ALLIANZ_ID, DLG_ID, LV_ID, VIZION_ID, NARG_ID];